import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Overview from "./pages/Overview";
import Investment from "./pages/Investment";
import Execution from "./pages/Execution";
import Contact from "./pages/Contact";
import SupplyChain from "./pages/SupplyChain";
import FinancialModel from "./pages/FinancialModel";
import Seza from "./pages/Seza";
import Solar from "./pages/Solar";
import Partner from "./pages/Partner";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Portal from "./pages/Portal";
import AdminDashboard from "./pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname } = useLocation();
  const isAuthRoute = ["/login", "/register"].includes(pathname);
  return (
    <>
      <ScrollToTop />
      {!isAuthRoute && <Navbar />}
      <main>
        <Routes>
          <Route path="/" element={<Overview />} />
          <Route path="/investment" element={<Investment />} />
          <Route path="/execution" element={<Execution />} />
          <Route path="/supply-chain" element={<SupplyChain />} />
          <Route path="/financial-model" element={<FinancialModel />} />
          <Route path="/seza" element={<Seza />} />
          <Route path="/solar" element={<Solar />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/portal"
            element={
              <ProtectedRoute>
                <Portal />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute requireAdmin>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
      {!isAuthRoute && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
